<template>
<div class="common-guide" :class="[type]" v-if="unhideGuideList.length > 0">
  <div class="mask" v-if="mask"></div>
  <div
    class="guide-item"
    v-for="guide of unhideGuideList"
    :key="guide.name"
    :style="guide.style"
  >
    <div class="arrow" :style="guide.arrowStyle"></div>
    <div class="close" @click="hideGuide(guide)">
      <icon type="close" color="#FFF"></icon>
    </div>
    <div class="title">{{ guide.title }}</div>
    <div class="detail" v-html="guide.detail" />
    <div class="hide">
      <span @click="hideGuide(guide)">{{t('guide.hideGuide')}}</span>
    </div>
  </div>
</div>
</template>

<script>
import Icon from './icon'
import i18nHandle from '../locales'

export default {
  components: {
    Icon,
  },
  props: {
    mask: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'menu', // menu, module
    },
    guides: {
      type: Array,
      default() {
        return []
      },
    },
    onHide: {
      type: Function,
      default() {},
    },
  },
  data () {
    return {
      guideList: this.guides.map(guide => {
        const flag = localStorage.getItem(`GUIDE_${guide.name}`)
        return Object.assign({
          flag: flag && Boolean(Number(flag)),
        }, guide)
      }),
    }
  },
  computed: {
    unhideGuideList() {
      return this.guideList.filter(guide => !guide.flag)
    },
  },
  methods: {
    hideGuide(guide) {
      /* eslint no-param-reassign: ["error", { "props": false }] */
      localStorage.setItem(`GUIDE_${guide.name}`, 1)
      guide.flag = true
      this.onHide(guide)
    },
    t: i18nHandle.t,
  },
}
</script>

<style lang="scss">
@import '../assets/styles/_variable';

.common-guide {
  position: fixed;
  top: $layoutHeaderHeight;
  height: calc(100% - #{$layoutHeaderHeight});
  width: 0;
  z-index: 10000;
  &.module {
    left: $layoutSidebarWidth;
  }
  &.menu {
    left: $layoutSidebarWidth + $layoutSiderbarMenuWidth;
  }
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
  }
  .guide-item {
    position: absolute;
    left: 12px;
    box-sizing: border-box;
    width: 200px;
    min-height: 120px;
    padding: 12px;
    border-radius: 2px;
    background: rgba(39, 45, 56, 0.9);
    border-radius: 6px;

    .arrow {
      position: absolute;
      left: 0;
      width: 0;
      height: 0;
      border-width: 6px 6px 6px 0;
      border-style: solid;
      border-color: transparent rgba(39, 45, 56, 0.9) transparent transparent;
      font-size: 0;
      line-height: 0;
      transform: translateX(-100%);
    }

    .close {
      position: absolute;
      top: 8px;
      right: 8px;
      line-height: 1;
      cursor: pointer;
    }

    .title {
      color: #fff;
      font-size: 14px;
      font-weight: bold;
    }
    .detail {
      margin: 16px 0;
      color: #fff;
      font-size: 12px;
      line-height: 16px;
    }

    .hide {
      color: #fff;
      font-size: 12px;
      text-align: right;
      cursor: pointer;
    }
  }
}
</style>

